// Branding & contact details — env-driven with safe defaults for build-time SSR / react-snap.
const env = (typeof process !== "undefined" && process.env) || {};

export const BRAND = {
  name: "Na Ponta Da Língua Brasil",
  shortName: "NPDL Brasil",
  teacher: "Professor Lionel",
  email: env.REACT_APP_CONTACT_EMAIL || "lionel@npdlbr.com.br",
  website: env.REACT_APP_SITE_URL || "https://npdlbr.com.br",
  websiteDisplay: (env.REACT_APP_SITE_URL || "https://npdlbr.com.br").replace(/^https?:\/\//, ""),
  instagram: "https://www.instagram.com/francescomlionel",
  instagramHandle: "@francescomlionel",
  // WhatsApp — Rio de Janeiro number
  whatsappNumber: env.REACT_APP_WHATSAPP_NUMBER || "5521998828573",
  whatsappDisplay: env.REACT_APP_WHATSAPP_DISPLAY || "21-99882-8573",
};

export const whatsappLink = (text) => {
  const message = encodeURIComponent(
    text || "Olá Professor Lionel! Quero agendar minha aula grátis de francês."
  );
  return `https://wa.me/${BRAND.whatsappNumber}?text=${message}`;
};
